<template>

    <v-layout wrap>
        <v-flex xs12 py-1>
            <v-card height="58" flat color="grey lighten-2" class="kim-card py-0">

                <v-card-title class="py-1">
                    <v-avatar size="40">
                        <img :src="avatar" />
                    </v-avatar>

                    <div class="subtitle ml-2">{{label}}: <br><span class="title font-weight-regular">{{client.firstName}} {{client.lastName}}</span></div>

                    <v-spacer></v-spacer>
                    <v-btn @click="$emit('remove')" color="error" fab small flat>
                        <v-icon>fa-trash</v-icon>
                    </v-btn>
                </v-card-title>

            </v-card>

            <!-- internal data editing -->

        </v-flex>
    </v-layout>

</template>
<script>

    import {getLabel} from '@/utils/Institution'
    import {getFakeAvatar} from '@/utils/Common'

    export default{
        props:{
            removeBtn:{
                type: Boolean,
                default: true
            },
            client: {
                type: Object,
                required: true
            },
            internal: {
                type: Boolean,
                default: false
            },
            label:{
                type: String,
                default: getLabel('commons.client.singular')
            }
        },
        computed: {
            avatar(){
                var vm = this
                return vm.client.avatar || getFakeAvatar(vm.client.gender)
            }
        },
        methods:{
            getLabel
        }
    }
</script>